// extracted by mini-css-extract-plugin
module.exports = {"base":"sg6riw0NyrFzaSeBrUURqg==","opaque":"SRkBuPFXb4-JQr7uG0le7Q=="};